<template>
	<div class="main-wrapper">
		<!---Navigation :logo="require('@/assets/images/logo/logohbv.png')"-->
		 <Navbar :topbarColor="topbarColor"   :static-position="staticPosition"/>
		<!---Sidebar-->
		 <SideBar parent=".main-wrapper" :sidebarLinks="sidebarLinks" :static-position="false"/>
		<!---Page Container-->
		<div class="main-container-fluid" :class="{ 'sidebar-active': isSidebarActive }">
      <div>
        <router-view></router-view>
      </div>
		</div>
	</div>
</template>

<script>
	
	import Navbar from './header/Navbar.vue';
	import SideBar from './sidebar/SideBar.vue';
	import sidebarLinks from './sidebar/sidebarlinks.js';

	export default {
		name: "MainContainer",
		components: {
      Navbar,
      SideBar
		},

		data:() => ({
			topbarColor: "#EE303A",
			logotitle: "HBV Etkinlik",
			sidebarLinks: sidebarLinks,
      staticPosition: true,
		}),

    computed: {
      isSidebarActive() {
        return this.$store.state.isSidebarActive
      }
    },

		methods: {
			
		},
	}  	
</script>

<style>
.vs-navbar {
    
   position: fixed !important;
    width: 100% !important;
    top: 0 !important;
}
.vs-sidebar--items{
	font-weight:bold;
}
</style>